import styled from 'styled-components';

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #258BE0;
  border-radius: 12px;
  width: 343px;
  height: 54px;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  border: none;
  color: white;
  letter-spacing: 1.5px;
  text-decoration: none;
  font-family: Montserrat;
  &:disabled{
    background: #9393A9;
    color: white;
  }
`;
